var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('KeepAlive',[(_vm.currentEvent)?_c(_vm.currentEvent,{ref:_vm.currentEvent.name,tag:"component",attrs:{"card":_vm.card,"selectedCards":[_vm.card.id],"modalType":'add',"eventManager":{'cascate': true, 'hasNext': this.events.length > 1}},on:{"Submit":_vm.handleOk,"Abort":_vm.handleCancel}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ed09ef2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/crm/board/modal/event/EventManager.vue
// module id = null
// module chunks = 